import { Loader2, Download, MessageCircle } from "lucide-react";
import BeforeAfter from "@/components/BeforeAfter";
import { toast } from "sonner";
import { trackConversion, trackClick } from "@/lib/analytics";

function LoadingState() {
  return (
    <div className="aspect-[16/9] shimmer rounded-2xl flex items-center justify-center" data-testid="generate-loading">
      <div className="text-center">
        <Loader2 size={40} className="animate-spin text-sky-500 mx-auto mb-4" />
        <p className="text-slate-600 text-sm">Mendesain ulang ruangan Anda…</p>
      </div>
    </div>
  );
}

function ReadyState({ before, after }) {
  const downloadAndRedirect = () => {
    const a = document.createElement("a");
    a.href = after;
    a.download = `ai-at-studio-design-${Date.now()}.png`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    toast.success("Desain berhasil diunduh! Lanjut konsultasi untuk realisasi.");
    trackConversion("design_download");
    setTimeout(() => {
      document.getElementById("konsultasi")?.scrollIntoView({ behavior: "smooth" });
    }, 600);
  };

  return (
    <>
      <BeforeAfter before={before} after={after} />
      <div className="mt-6 flex flex-wrap items-center gap-4">
        <button
          onClick={downloadAndRedirect}
          data-testid="download-design-button"
          className="inline-flex items-center gap-3 bg-gradient-to-r from-sky-500 to-cyan-500 hover:from-sky-600 hover:to-cyan-600 text-white font-semibold text-xs uppercase tracking-[0.2em] px-7 py-4 rounded-full shadow-lg shadow-sky-200 transition-colors"
        >
          <Download size={16} /> Unduh Hasil
        </button>
        <button
          onClick={() => { trackClick("result_goto_consultation"); document.getElementById("konsultasi")?.scrollIntoView({ behavior: "smooth" }); }}
          data-testid="proceed-to-consultation-button"
          className="inline-flex items-center gap-3 bg-white text-slate-800 border border-slate-200 hover:border-sky-300 hover:text-sky-600 text-xs uppercase tracking-[0.2em] px-7 py-4 rounded-full transition-colors"
        >
          <MessageCircle size={14} /> Konsultasi Gratis
        </button>
      </div>
      <p className="mt-4 text-xs text-slate-500 max-w-xl">
        Suka dengan hasilnya? Lanjutkan ke konsultasi gratis — tim desainer kami akan membantu Anda
        merealisasikan desain ini menjadi ruangan nyata.
      </p>
    </>
  );
}

export default function GenerateResult({ loading, generated, previewUrl }) {
  if (loading) return <LoadingState />;
  if (generated && previewUrl) return <ReadyState before={previewUrl} after={generated} />;
  return null;
}
